/* eslint-disable */
/**
 * This file should closely match the one in PET
 * source: https://bitbucket.nike.com/projects/RUX/repos/premium-experience-toolkit/browse/packages/ux-tread-privacy/src/eu-cookie-countries.js
 */
const EU_COOKIE_COUNTRIES = {
  AT: 'Austria',
  BE: 'Belgium',
  BG: 'Bulgaria',
  HR: 'Croatia',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  EE: 'Estonia',
  FI: 'Finland',
  FR: 'France',
  DE: 'Germany',
  GR: 'Greece',
  HU: 'Hungary',
  IE: 'Ireland, Republic of (EIRE)',
  IT: 'Italy',
  LV: 'Latvia',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MT: 'Malta',
  NL: 'Netherlands',
  NO: 'Norway',
  PL: 'Poland',
  PT: 'Portugal',
  RO: 'Romania',
  SK: 'Slovakia',
  SI: 'Slovenia',
  ES: 'Spain',
  SE: 'Sweden',
  CH: 'Switzerland',
  GB: 'United Kingdom'
};

export function isCookieRequiredCountry(countryName: string = ''): boolean {
  return !!(EU_COOKIE_COUNTRIES as any)[countryName.toUpperCase()];
}
